module.exports = __webpack_public_path__ + "fonts/819e937.woff";